/** Lectura de archivos clínicos (imagen / PDF) con validación unificada. */

export function isPdfFile(file) {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  return type === 'application/pdf' || name.endsWith('.pdf');
}

export function isImageFile(file) {
  if (!file) return false;
  return (file.type || '').startsWith('image/');
}

export function isClinicalAttachmentFile(file) {
  return isImageFile(file) || isPdfFile(file);
}

/**
 * Lee archivo como data URL.
 * @param {File} file
 * @param {{ maxImageBytes?: number, maxPdfBytes?: number }} limits
 */
export function readFileAsDataUrl(file, limits = {}) {
  const maxImage = limits.maxImageBytes ?? 3 * 1024 * 1024;
  const maxPdf = limits.maxPdfBytes ?? 15 * 1024 * 1024;

  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No se seleccionó archivo.'));
      return;
    }
    let pdf = isPdfFile(file);
    let img = isImageFile(file);
    if (!pdf && !img) {
      const name = (file.name || '').toLowerCase();
      if (name.endsWith('.pdf')) pdf = true;
      else if (/\.(jpe?g|png|webp|gif|bmp|heic)$/.test(name)) img = true;
    }
    if (!pdf && !img) {
      reject(new Error('Formato no admitido. Use imagen (JPG, PNG…) o PDF.'));
      return;
    }
    const max = pdf ? maxPdf : maxImage;
    if (file.size > max) {
      reject(new Error(pdf
        ? `El PDF no debe superar ${Math.round(maxPdf / (1024 * 1024))} MB.`
        : `La imagen no debe superar ${Math.round(maxImage / (1024 * 1024))} MB.`));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const url = typeof reader.result === 'string' ? reader.result : '';
      if (!url) {
        reject(new Error('No se pudo leer el archivo.'));
        return;
      }
      resolve({
        dataUrl: url,
        mime: file.type || (pdf ? 'application/pdf' : 'image/jpeg'),
        sizeBytes: file.size || 0,
        nombre: file.name || '',
        esPdf: pdf,
      });
    };
    reader.onerror = () => reject(new Error('Error al leer el archivo.'));
    reader.readAsDataURL(file);
  });
}
